import {Component, OnInit, Input, OnDestroy, ViewChild, Host, Optional} from '@angular/core';
import {Project} from '../../../../data/project/project';
import {ProjectActivityDialogComponent} from '../../../project-activity-dialog/project-activity-dialog.component';
import {ProjectActivityService} from '../../../../data/project/activity/project-activity.service';
import {ProjectActivity} from '../../../../data/project/activity/project-activity';
import {distinctUntilChanged, debounceTime, filter, takeUntil, tap} from 'rxjs/operators';
import {ProjectService} from '../../../../data/project/project.service';
import {merge, Subject, Subscription} from 'rxjs';
import {WsService} from 'projects/app-misc/src/app/modules/data/ws.service';
import {WsUpdateResponce} from 'projects/app-misc/src/app/modules/data/ws-update-responce';
import {MatDialog} from '@angular/material/dialog';
import {RxJSUnsubscribe} from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import {RxJSUnsubscribable} from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';
import { ProjectInfoBlockComponent } from '../project-info-block.component';

@Component({
  selector: 'app-due-date',
  templateUrl: './due-date.component.html',
  styleUrls: ['./due-date.component.scss']
})
@RxJSUnsubscribe
export class DueDateComponent implements OnInit, OnDestroy, RxJSUnsubscribable {

  @Input()
  project: Project;

  projectActivity: ProjectActivity;

  dateCode: string;
  dateFullCode: string;

  wsSub: Subscription;

  deliveryInstructions: string;

  constructor(
    protected dialog: MatDialog,
    protected projectService: ProjectService,
    protected projectActivityService: ProjectActivityService,
    protected wsService: WsService,
    @Optional() protected parentComponent: ProjectInfoBlockComponent
  ) {
  }

  ngOnInit() {
    this.findActivity();

    this.projectActivityService
        .projectActivityEmitter
        .remove
        .pipe(takeUntil(this.getUnsubFromAllSubs()))
        .subscribe(event => {
            if (this.projectActivity && this.projectActivity.id === event.entityId) {
              console.log('Removing project activity 1, ', event.entityId);
              this.projectActivity = null;
              this.project.finishDate = null;
            }
        })

    merge(
      this.projectActivityService
        .projectActivityEmitter
        .add
        .pipe(filter(event => event.entity.project.id === this.project.id))
        .pipe(
            tap(event => {
                  if (!this.projectActivity && event.entity.type.major) {
                    this.projectActivity = event.entity;
                    this.project.finishDate = this.projectActivity.startDate;
                  }
                }
            )
        ),

      this.projectActivityService
        .projectActivityEmitter
        .update
        .pipe(filter(event => event.entity.project.id === this.project.id))
        .pipe(
            tap(event => {
              if (this.projectActivity && this.projectActivity.id === event.entityId) {
                  this.projectActivity.startDate = event.entity.startDate;
                  this.project.finishDate = this.projectActivity.startDate;
                }
              }
            )
        )
    )
      .pipe(
        takeUntil(this.getUnsubFromAllSubs()),
        debounceTime(50),
      )
      .subscribe(() => {
        this.findActivity();
      })


    this.wsSub = this.wsService
      .listenUntilDestroyed<WsUpdateResponce<Project>>('/topic/update/model.project.Project', this)
      .pipe(
        filter(updateInfo => updateInfo.entity.id === this.project.id),
        filter(updateInfo =>
          typeof updateInfo.entity.jobDeliveryDate !== 'undefined'
          || typeof updateInfo.entity.clientPickupDate !== 'undefined'
          || typeof updateInfo.entity.punchListDueDate !== 'undefined'
          || typeof updateInfo.entity.finishDate !== 'undefined'),
        debounceTime(2000)
      )
      .subscribe(() => {
        this.getActivities();
      })

    this.projectActivityService.getMajorActivityTypes().subscribe()
  }

  getActivities() {

    this.projectActivityService.getProjectActivities(this.project.id).subscribe(projectActivities => {
      this.project.activities = projectActivities
      this.findActivity();
    })
  }

  findActivity() {
    this.projectActivity = null;

    let earliestNonReadyActivity = null;
    let latestReadyActivity = null;

    for (const activity of this.project.activities) {
      if (!activity.type.major) continue;

      if (!activity.ready) {
        if (!earliestNonReadyActivity || activity.startDate < earliestNonReadyActivity.startDate) {
          earliestNonReadyActivity = activity;
        }
      } else {
        if (!latestReadyActivity || activity.startDate > latestReadyActivity.startDate) {
          latestReadyActivity = activity;
        }
      }
    }

    if (earliestNonReadyActivity) {
      this.projectActivity = earliestNonReadyActivity;
    } else if (latestReadyActivity) {
      this.projectActivity = latestReadyActivity;
    } else {
      // console.log('No major activities found');
    }

    if (this.projectActivity) {
      this.dateCode = this.projectActivity.type.shortCode;
      this.dateFullCode = this.projectActivity.type.title;

      if (this.projectActivity.deliveryInstructions) {
        this.deliveryInstructions = this.projectActivity.deliveryInstructions;
      }
    }
  }

  editProjectActivity(): void {
    this.projectActivityService.getMajorActivityTypes().subscribe(types => {
      const activityTypes = types

      if (this.projectActivity) {
        this.dialog.open(ProjectActivityDialogComponent, {
          data: {
            projectActivity: this.projectActivity,
            project: this.project,
            buttonLabel: 'Save',
            types: activityTypes
          },
          disableClose: true
        });
      } else {
        this.dialog.open(ProjectActivityDialogComponent, {
          data: {
            projectActivity: this.projectActivity,
            project: this.project,
            buttonLabel: 'Add',
            types: activityTypes
          },
          disableClose: true
        });
      }

    })
  }

  isTypeNone(): boolean {
    return this.project.type?.name === 'none';
  }

  handleClick(): void {
    if (this.isTypeNone()) {
      if (this.parentComponent?.projectTypeDropdown) {
        this.parentComponent.projectTypeDropdown.showDropdown();
      } else {
        console.error('Parent component or projectTypeDropdown not found');
      }
    } else {
      this.editProjectActivity();
    }
  }

  ngOnDestroy() {
    if (this.wsSub) {
      this.wsSub.unsubscribe()
      this.wsSub = null;
    }
  }

  getUnsubFromAllSubs(): Subject<boolean> {
    return null
  }

}
